import React from "react";

export default function AiWhyChooseUs() {
  return (
    <React.Fragment>
      <div className="row mb-5 latestApiDevelopmentDiv px-6">
        <div className="col-12 text-center py-4">
          <h2>Why Choose Us ?</h2>
        </div>
        <div className="col-md-6">
          <div className="aiServiceCard p-3">
            <div className="d-flex justify-content-between">
              <img
                src="/images/AiServicesImage7.png"
                alt="AI Consultation and Strategy"
              />
              <b>01</b>
            </div>
            <h3 className="mt-4">Expert-Led Development</h3>
            <p className="mb-0">
              We have a team of AI professionals, developers, and engineers with
              deep knowledge of various AI technologies. We use this knowledge
              to develop scalable and reliable intelligent solutions.
            </p>
          </div>
        </div>
        <div className="col-md-6 mt-3 mt-md-0">
          <div className="aiServiceCard p-3">
            <div className="d-flex justify-content-between">
              <img
                src="/images/AiServicesImage8.png"
                alt="AI Consultation and Strategy"
              />
              <b>02</b>
            </div>
            <h3 className="mt-4">Custom Solutions</h3>
            <p className="mb-0">
              We understand that every business meets with different challenges
              which can't be solved with a generic AI solution. Therefore, we
              use a consultative approach to develop custom AI solutions that
              align best with your workflow and business goals.
            </p>
          </div>
        </div>
        <div className="col-md-6 mt-3">
          <div className="aiServiceCard p-3">
            <div className="d-flex justify-content-between">
              <img
                src="/images/AiServicesImage9.png"
                alt="AI Consultation and Strategy"
              />
              <b>03</b>
            </div>
            <h3 className="mt-4">Expert Team</h3>
            <p className="mb-0">
              We have an experienced team of AI professionals who use new
              technologies and proven methods to make sure your project exceeds
              expectations. Our AI experts have deep knowledge of various
              industries to lead the AI innovation and deliver results with
              accuracy.
            </p>
          </div>
        </div>
        <div className="col-md-6 mt-3">
          <div className="aiServiceCard p-3">
            <div className="d-flex justify-content-between">
              <img
                src="/images/AiServicesImage10.png"
                alt="AI Consultation and Strategy"
              />
              <b>04</b>
            </div>
            <h3 className="mt-4">Proven Track Record</h3>
            <p className="mb-0">
              We have a track record of completing projects on time and within
              the allocated budget, whether it’s automating complex processes or
              developing intelligent apps. We aim to build a long term
              relationship with our clients and offer them extended support even
              after the project completion.
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
